<div> 
  <div class="card">
    <div class="card-header">
      <p>Ingrese los datos del nuevo usuario</p>
    </div>
    <div class="card-body">
      <div class="container">
          <div class="row">
              <div class="col">
                <input type="text"  [(ngModel)]="nombre" (input)="validaboton()" class="form-control" placeholder="Nombre"  >
              </div>
              <div class="col">
                <!-- <input type="text"  [(ngModel)]="empresa" (input)="validaboton()" class="form-control" placeholder="Empresa"  >  -->
                <div class="col">
                  <div class="form-group">
                    <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="empresa">
                      <option *ngFor="let item of arraydeempresas">{{item.data().nombre}}</option>
                    </select>
                  </div>
            </div>
              </div>
          </div>
          <div class="row">
            <div class="col">
              <input type="text" [(ngModel)]="email" class="form-control" (input)="validaboton()"  placeholder="email" >
            </div>
            <div class="col">
              <input type="text" [(ngModel)]="password" (input)="validaboton()"  class="form-control" placeholder="Clave">
            </div>
          </div>
  

      </div>
      <div *ngIf="alertaActiva">
          <p>
              <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span *ngIf="creandousuario" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
          </p>
      </div>

      
      <div>
        <button class="btn btn-danger btn-block" (click)="crearUsuario()" style="float: right; margin-right: 6px;" [disabled]="botondisabled">¡Crear usuario!</button>
      </div>
    </div>
  </div>
</div>

<table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"   >
    <thead>
      <tr>
        <th>Acciones</th>
        <th>nombre</th>
        <th>email</th>
        <th>empresa</th>
      </tr>
    </thead>
    <tbody>
       

      <tr *ngFor="let item of arraydeposts">
        <td><button type="button" class="btn btn-primary btn-sm" (click)="detallesUsuario(item)"> Acciones</button></td>
        <td><small>{{item.data().nombre}}</small></td>
        <td><small>{{item.data().email}}</small></td>
        <td><small>{{item.data().empresa}}</small></td>
      </tr>
      
    </tbody>
  </table>
